/**
 * Web component: Lab files (lab-files)
 * -----------------------------------------------------------------------------
 * A section that pulls lab files from a metaobject called "Lab Files".
 * - Component settings: section / limited / web / vanilla
 *
 */
import './lab-files.scss';

import { vueReady } from '~/core/runners';

/**
 * Create new <lab-files> custom element.
 */
class LabFiles extends HTMLElement {
  data() {
    return {
      button: this.querySelector('.lab-files__show-more'),
      sectionId: this.closest('section')?.id,
    };
  }

  constructor() {
    super();
    this.$data = this.data(this);
  }

  connectedCallback() {
    this.$data.button?.addEventListener('click', this.openOverlay.bind(this));
  }

  openOverlay() {
    // Extract section ID to build namespace
    const sectionId = this.$data.sectionId?.replace('lab-files-', '');

    if (sectionId) {
      // Emit event to open overlay using the overlay store
      cnvs.EventBus.emit('overlay:open', {
        ignoreDismissed: true,
        namespace: `lab-files-${sectionId}`,
      });
    }
  }
}

/**
 * Define web component on Vue initialisation.
 */
vueReady(() => {
  if (customElements.get('lab-files')) {
    return;
  }

  customElements.define('lab-files', LabFiles);
});
